var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-img-top"},[_c('img',{staticClass:"special_img card-img-top",attrs:{"src":_vm.image,"alt":_vm.alt}})]),_c('div',{staticClass:"card-body"},[_vm._t("p-1")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }